import {mapActions} from "vuex";

export default {
    beforeMount() {
        this._getTableTypes();
    },
    methods: {
        ...mapActions({
            setFilteredRawTablesTypesList(dispatch, payload){
                return dispatch(this.namespace + '/setFilteredRawTablesTypesList', payload);
            },
        }),
        _getTableTypes() {
            var that = this;
            let objects = this.$store.dispatch(this.namespace + '/getRawTablesTypes');

            objects.then(function (result) {
                that._storeTableTypes(result.rawDataPartnersTableTypes.edges);

            }).catch(function (thr) {
                console.log(thr);
            });
        },

        _storeTableTypes(typeList) {
            typeList = typeList.map(item => item.node);
            this.$store.dispatch(this.namespace + '/setTablesTypesList', typeList, {root: true});
        },

        getRawTablesTypesList: function () {
            return this.$store.getters[this.namespace + '/getRawTablesTypesList'];
        },
        getSelectedRawTablesTypesList: function () {
            return this.$store.getters[this.namespace + '/getSelectedRawTablesTypesList'];
        },
        getSelectedRawTablesTypesObjects(){
            return this.$store.getters[this.namespace + '/getSelectedRawTablesTypesObjects'];
        },
        updateFilteredRawTablesTypesList(value){
            this._setFilteredRawTablesTypesList(value);
            this.clearPagination();
            this.setUpdatingStatus(true);
            this.startLoading();
            this.checkFilters();
        },
        removeFilteredRawTablesTypesList(value){
            this.updateFilteredRawTablesTypesList(value);
            this.removeParamFromUrl('rawTablesTypes');
        },
        _setFilteredRawTablesTypesList(value) {
            this.setFilteredRawTablesTypesList(value);
        },
    },
    getRawTablesTypesList(){
        return this.$store.getters.getRawTablesTypesList;
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/rawPartnersDataReportMixin.js